// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"453":"component---src-pages-404-tsx","966":"component---src-templates-standard-page-index-tsx"}[chunkId] || chunkId) + "-" + {"157":"72d611749a5a69907faa","453":"bc7a00d3d23a555ae6a5","556":"32a89288f7e3a5fbf94c","966":"199246b13e9f0e917e71"}[chunkId] + ".js";
};